import { Controller } from "@hotwired/stimulus";

// Auto-calculates Total con IVA from Precio total sin IVA and IVA %
// Targets: totalWithoutVat, vatRate, totalWithVat
export default class extends Controller {
    static targets = ["totalWithoutVat", "vatRate", "totalWithVat"];

    connect() {
        this.onChange = this.recalculate.bind(this);
        this.totalWithoutVatTargets.forEach((el) => el.addEventListener("input", this.onChange));
        this.vatRateTargets.forEach((el) => {
            el.addEventListener("change", this.onChange);
            el.addEventListener("input", this.onChange);
        });
        this.recalculate();
    }

    disconnect() {
        this.totalWithoutVatTargets.forEach((el) => el.removeEventListener("input", this.onChange));
        this.vatRateTargets.forEach((el) => {
            el.removeEventListener("change", this.onChange);
            el.removeEventListener("input", this.onChange);
        });
    }

    recalculate() {
        const ht = this.parseNumber(
            this.totalWithoutVatTargets[0] ? this.totalWithoutVatTargets[0].value : null
        );
        const rate = this.parseNumber(
            this.vatRateTargets[0] ? this.vatRateTargets[0].value : null
        );
        const target = this.totalWithVatTargets[0];
        if (!target) return;
        if (ht == null || rate == null) {
            target.value = "";
            target.dispatchEvent(new Event("input", { bubbles: true }));
            return;
        }
        const ttc = ht * (1 + rate / 100);
        target.value = isFinite(ttc) ? ttc.toFixed(2) : "";
        target.dispatchEvent(new Event("input", { bubbles: true }));
    }

    parseNumber(val) {
        if (val == null || String(val).trim() === "") return null;
        const s = String(val).replace(/\s|\u00A0/g, "").replace(/,/g, ".");
        const n = Number(s);
        return isNaN(n) ? null : n;
    }
}
